import { gql } from '@apollo/client'

export default gql`
    fragment adminImModelConfiguration on ModelConfiguration {
        id
        dfmInspection {
            id
            inspectionData
            isPublished
            quotedBy {
                id
                displayName
            }
            quotedAt
            quoteUpdatedBy {
                id
                displayName
            }
            quoteUpdatedAt
            updatedAt
        }
        productionLeadTime {
            id
            priorityId
            productionDays
            primaryProductionDays
            shipDateEstimate {
                id
                validUntilDate
                shippedByDate
            }
        }
        process {
            id
            name
        }
        material {
            __typename
            ... on Material {
                id
                name
            }
            ... on UserEnteredMaterial {
                id
                name
            }
        }
        materialGrade
        color {
            id
            name
        }
        colorCode
        textureCode
        hasMultipleFinishes
        userNeedsConfigHelp
        quantity
        errorCode
        updatedAt
        updatedBy {
            id
            email
            updatedAt
        }
        toolDetails {
            totalCost
            tools {
                id
                type
                diameter
                length
                ratio
                price
            }
        }
    }
`
